import {
  CHECK_QUESTION,
  UPDATE_QUESTION_SETTING,
  UPDATE_CHOICES_LIST,
  REORDER_QUESTIONS,
  DELETE_QUESTION,
  UPDATE_FORM_SETTINGS,
  ADD_LANGUAGES,
  SET_DEFAULT_LANGUAGE,
  REMOVE_LANGUAGE,
  CHANGE_TAB,
  SURVEY_TAB,
  ADD_NEW_QUESTION,
  SORT_QUESTIONS,
  ADD_SCREEN,
  SET_CURRENT_SCREEN,
  TOGGLE_DRAWER,
  DELETE_SCREEN,
  CLONE_QUESTION,
  ADD_QUESTION_INTO_PARENT,
  TAKE_OUT_GROUP_QUESTIONS,
  SORT_IN_GROUP_QUESTIONS,
  ADD_NEW_QUESTION_INTO_GROUP,
  ADD_NEW_GROUP_QUESTION,
  UPDATE_CHOICES_LIST_INIT,
  SET_PREVIEW,
  UPDATE_THEME_SETTING,
  UPDATE_FORM_CONFIGS,
  UPDATE_CONFIG_TEMP
} from "./constants";
import { CALCULATE_QUESTION_TYPE, GROUP_QUESTION_TYPE } from "./function/templates";
import { GENERAL_QUESTION_SETTINGS } from "./function/question_settings";
import { getVersion } from "./function/helpers";
import { generateQuestionName } from "./function/utils";
import { deleteItem } from "./function/select_function";

let initState = {
  previewForm: false,
  questions: {},
  questionsList: {
    1: {
      name: "group_1",
      type: GROUP_QUESTION_TYPE,
      appearance: "field-list grid(weight = 6)",
      collector: {
        Appearance: "TRUE",
      },
    },
    language : {
      name : "language",
      type :"select_one language",
      appearance :"change_language text-nolabel",
    },
    displaytitle : {
      name : "displaytitle",
      type :"text",
      appearance :"displaytitle invisible",
      display :["displaytitle invisible"],
      relevant: true,
      label: "Form title"
    }
  },
  pages: {
    1: [],
  },
  current_page: "1",
  question_checked: "",
  question_checked_settings: "",
  choices_list: [
    [
      "list_name",
      "name",
      "label::en",
      "label::vi",
      "filter",
      "media::image::en",
      "media::image::vi",
    ],
  ],
  languages: ["en", "vi"],
  text: {},
  form_settings: {
    form_title: "",
    form_id: "_G1",
    version: getVersion(),
    instance_name: "concat(${uuid_ssname})",
    public_key: "",
    submission_url: "",
    default_language: "en",
    generation: 1,
    family: "",
  },
  tab: SURVEY_TAB,
  drawer: {
    left: false,
    questionConfig: false,
  },
  theme_config:{
    primary_color:"#009688",
    accent_color:"#ffffff",
    background_color:"#ffffff",
    question_color:"#000000",
    answer_color:"#000000",
    background_image:"url()",
    background_brightness:"50",
    logo:"",
    font_size:"25px",
    font_family:"Montserrat",
    position_pagination:"right",
    show_shortcuts:"0",
    type_shortcuts:"text",
    show_powered_btn:"1",
    show_scroll:"0",
    show_welcome_screen:"0",
    intro_content:"",
    hide_header:"5",
    icon_rating:"",
    logo_size:"50"
  },
  form_configs: {
    change_language: "1",
    save_mid: "0",
    jump_to: "0",
    autosend_wifi: "1",
    autosend_network: "1",
    show_welcome_screen: "0",
    show_final_screen: "0",
    buttons: "1",
    validate_form: "0",
    simplify_form: "0",
    simplify_auto: "auto",
  },
  config_temp: {}
};

export function rootReducer(state = initState, action) {
  let newState = { ...state };
  try {
    let newQuestionsList = {};
    let newQuestion = {}
    switch (action.type) {
      case SET_PREVIEW:
        newState.previewForm = action.value
        break;
      case UPDATE_CONFIG_TEMP:
        newState['config_temp'] = action.config
        break;
      case ADD_NEW_QUESTION:
        {
          const { question_id, question_type, question_collector, new_question, page_name, destination_index } = action;
          let newQuestion = JSON.parse(JSON.stringify(GENERAL_QUESTION_SETTINGS));
          newQuestion.name = question_id;
          newQuestion.type = question_type === 'button' ? 'text' : question_type;
          newQuestion.collector = question_collector;
        
          if (question_type !== CALCULATE_QUESTION_TYPE && newQuestion.type !== GROUP_QUESTION_TYPE) {
            newQuestion.gridformat = { row: -1, col: 0, rowspan: "", colspan: 6, align: "left" };
            newQuestion.appearance = setAppearance(newQuestion.display, newQuestion.gridformat);
          }
        
          // Add question from single template
          if (new_question) {
            newQuestion = handleQuestionSingleTemplate(action, new_question);
          }
        
          newState.questionsList[question_id] = newQuestion;
        
          if (newState.pages[page_name]) {
            newState.pages[page_name].splice(destination_index, 0, question_id);
          } else {
            newState.pages = { [page_name]: question_id };
          }
        
          if (newQuestion.type !== GROUP_QUESTION_TYPE && newQuestion.type !== CALCULATE_QUESTION_TYPE) {
            newState = handleGrid(newState, page_name);
          }
        
          // Check question config
          newState.question_checked = question_id;
          newState.question_checked_settings = { ...newState.questionsList[question_id] };
          newState = syncStateWithLanguages(newState);
        }
      
        break;
    
      case ADD_NEW_GROUP_QUESTION:
        newQuestion = JSON.parse(JSON.stringify(GENERAL_QUESTION_SETTINGS));
        newQuestion.name = action.question_id;
        newQuestion.type = action.question_type === 'button' ? 'text' : action.question_type;
        newQuestion.collector = action.question_collector;
        if (action.question_type !== CALCULATE_QUESTION_TYPE) {
          newQuestion["gridformat"] = {
            row: -1,
            col: 0,
            rowspan: "",
            colspan: 6,
            align: "left",
          };
        }
        if (newQuestion.type === "group_template") {
          let groupTemplateAttribute = window?.GroupTemplateParent[action.question_collector['AppearanceGroup']]
          newQuestion.display = [groupTemplateAttribute.display]
          newQuestion.name = groupTemplateAttribute.name ? groupTemplateAttribute.name : action.question_id;
          newQuestion.type = "group"
        }
        newState.questionsList[action.question_id] = newQuestion;

        if (newState.pages[action.page_name]) {
          newState.pages[action.page_name].splice(action.destination_index, 0, action.question_id);
        } else {
          newState.pages = { [action.page_name]: action.question_id};
        }
        handleNewListChild(action,state, newState)
        
        newState = handleGrid(newState, action.page_name)
        newState = syncStateWithLanguages(newState);
        //check question config
        newState.question_checked = action.question_id;

        newState.question_checked_settings = {...newQuestion};
      break;

      case ADD_NEW_QUESTION_INTO_GROUP:
        newQuestion = JSON.parse(JSON.stringify(GENERAL_QUESTION_SETTINGS));
        newQuestion.name = action.question_id;
        newQuestion.type = action.question_type;
        newQuestion.collector = action.question_collector;
        if (action.question_type !== CALCULATE_QUESTION_TYPE && action.question_type !== GROUP_QUESTION_TYPE) {
          newQuestion["gridformat"] = {
            row: -1,
            col: 0,
            rowspan: "",
            colspan: 6,
            align: "left",
          };
          newQuestion.appearance = setAppearance(newQuestion["display"],newQuestion["gridformat"]);
        }
        if(action.new_question){
          newQuestion = handleQuestionSingleTemplate(action,action.new_question)
        }
        newQuestion.parent = action.parent
        newState.questionsList[action.question_id] = newQuestion;

        if (newState.pages[action.page_name]) {
          newState.pages[action.page_name].splice(action.destination_index, 0, action.question_id );
        } else {
          newState.pages = { [action.page_name]: action.question_id, };
        }
        newState.questionsList[action.parent].children.splice( action.destination_index, 0, action.question_id);
        //check question config
        newState.question_checked = action.question_id;

        newState.question_checked_settings = {...newState.questionsList[action.question_id]};
        //
        const currentPage = state.pages[newState.current_page];
        currentPage.splice(currentPage.indexOf(action.question_id), 1);
        newState.pages[newState.current_page] = currentPage;
        if (newQuestion.type !== GROUP_QUESTION_TYPE && newQuestion.type !== CALCULATE_QUESTION_TYPE) {
          newState = handleGrid(newState, action.page_name)
        }
        newState = syncStateWithLanguages(newState);
      break;

      case SORT_QUESTIONS:
        newQuestionsList = [...newState.pages[newState.current_page]];
        const [removed] = newQuestionsList.splice(action.source_index, 1);
        newQuestionsList.splice(action.destination_index, 0, removed);
        newState.pages[newState.current_page] = newQuestionsList;
        newState = handleGrid(newState, newState.current_page)

        break;

      case CHECK_QUESTION:
        {
          const { question_id } = action;
          newState.question_checked = question_id;
          newState.question_checked_settings = newState.questionsList[question_id];
        }
        break; 

      case DELETE_QUESTION:
        {
          const { question_id, page_name } = action;
          let questions = { ...state.questionsList };
        
          // Delete question in parent
          const parentQuestion = questions[question_id]?.parent;
          if (parentQuestion && questions[parentQuestion]?.children?.length > 0) {
            const childParent = questions[parentQuestion].children;
            const childIndex = childParent.indexOf(question_id);
            if (childIndex > -1) {
              childParent.splice(childIndex, 1);
              questions[parentQuestion].children = childParent;
            }
          }
        
          // Delete child questions if it is a group
          questions[question_id]?.children?.forEach((child) => {
            delete questions[child];
          });
        
          delete questions[question_id];
          newState.questionsList = { ...questions };
        
          let questionsInPage = state.pages[page_name];
          const questionIndex = questionsInPage.indexOf(question_id);
          if (questionIndex > -1) {
            questionsInPage.splice(questionIndex, 1);
            newState.pages[page_name] = questionsInPage;
          }
        
          newState.question_checked = "";
          newState.question_checked_settings = "";
          newState = handleGrid(newState, page_name);
        }
        break;

      case CLONE_QUESTION:

        let newPage = [...newState.pages[newState.current_page]];
        const originQuestionIndex = newState.pages[newState.current_page].indexOf(action.questionId);
        const originQuestion = {...newState.questionsList[action.questionId]};
        const newQuestionName = generateQuestionName(originQuestion.collector.AppearanceGroup);
        const newQuestionData = { ...originQuestion,name: newQuestionName,};
        if(originQuestion.type === 'group' && originQuestion?.children?.length > 0){
          const childQues = originQuestion?.children?.map((child) => {
            const originQuestionChildIndex = newState.pages[newState.current_page].indexOf(child);
            const originQuestionChild = {...newState.questionsList[child]};
            const newQuestionChildName = generateQuestionName(originQuestionChild.collector.AppearanceGroup);
            const newQuestionChildData = { ...originQuestionChild,name: newQuestionChildName,};
            newState.questionsList = {...newState.questionsList,[newQuestionChildName]: newQuestionChildData,};
            // newPage.splice(originQuestionChildIndex + 1, 0, newQuestionChildName);
            // newState.pages[newState.current_page] = [...newPage];
            if (newQuestionChildData.type !== CALCULATE_QUESTION_TYPE && newQuestionChildData.type !== GROUP_QUESTION_TYPE) {
              newQuestionChildData.gridformat = {...newQuestionChildData.gridformat ,row :originQuestionChildIndex + 1}
              newQuestionChildData.appearance = setAppearance(newQuestionChildData.display, newQuestionData.gridformat);
              newState = handleGrid(newState, newState.current_page);
            }
            return newQuestionChildName
          })
          newQuestionData.children = childQues
        }
        newState.questionsList = {...newState.questionsList,[newQuestionName]: newQuestionData};
        const parrentQues = originQuestion?.parent
        if (newQuestionData.type !== CALCULATE_QUESTION_TYPE && newQuestionData.type !== GROUP_QUESTION_TYPE) {
          
          newQuestionData.gridformat = {...newQuestionData.gridformat ,row :originQuestionIndex + 1}
          newQuestionData.appearance = setAppearance(newQuestionData.display, newQuestionData.gridformat);
          newState = handleGrid(newState, newState.current_page);
        }
        if(!parrentQues){
          newPage.splice(originQuestionIndex + 1, 0, newQuestionName);
          newState.pages[newState.current_page] = [...newPage];
        }else{
          newState.questionsList[parrentQues].children = [...newState.questionsList[parrentQues].children,newQuestionName]
        }
        
        break;
      
      case REORDER_QUESTIONS:
        {
          const { page_name, from_index, to_index } = action;
          const questions = [...newState.pages[page_name]];
          const [removed] = questions.splice(from_index, 1);
          questions.splice(to_index, 0, removed);
        
          newState.pages[page_name] = questions;
        }
        break;

      case UPDATE_QUESTION_SETTING:
        if (action.question_setting_key === "display") {
          newState.questionsList[action.question_id][action.question_setting_key] = action.question_setting_value
          newState.questionsList[action.question_id]['question_appearance_value'] = action.question_appearance_value
        } else if (action.question_setting_key === "choices_list") {
          newState.questionsList[action.question_id] = {
            ...newState.questionsList[action.question_id],
            choices_list: action.question_setting_value,
            choice: action.question_setting_value,
            type:`${newState.questionsList[action.question_id].collector.XlsType.toLowerCase().replace(/\ /g, "_")} ${action.question_setting_value}`
          };
        } else if (action.question_setting_key === "grid") {
          newState.questionsList[action.question_id]["gridformat"]["colspan"] = parseInt(action.question_setting_value) || 0
        } else if (action.question_setting_key === "align") {
          newState.questionsList[action.question_id]["gridformat"]["align"] = action.question_setting_value || 'left'
        }else {
          newState.questionsList[action.question_id][action.question_setting_key] = action.question_setting_value;
        }
        newState = handleGrid(newState, newState.current_page)
        if (newState.questionsList[action.question_id].type !== GROUP_QUESTION_TYPE && newState.questionsList[action.question_id].type !== CALCULATE_QUESTION_TYPE) {
          newState.questionsList[action.question_id].appearance = setAppearance(newState.questionsList[action.question_id]["display"],newState.questionsList[action.question_id]["gridformat"]);
        }
        if(action.question_id !== "displaytitle" && action.question_id !== "language"){
          newState.question_checked_settings =
          newState.questionsList[action.question_id];
        }
        
        break;

      case UPDATE_CHOICES_LIST:
        let newData = [...state.choices_list];
        action.dataChanges.forEach(([row, column, oldValue, newValue]) => {
          if (!newData[row]) {
            const newRow = Array.apply("", Array(newData[0].length));
            newData = [...newData, newRow];
          }
          newData[row][column] = newValue;
        });

        newState = { ...state, choices_list: newData};
        break;

      case UPDATE_CHOICES_LIST_INIT:
        if(action.choiceName){
          newState['questionsList'][action.question_id]['choice'] = action.choiceName
        }
        newState.questionsList[action.question_id] = {
          ...newState.questionsList[action.question_id],
          choices_list: action.choiceName,
          type:
          (
            newState.questionsList[action.question_id].collector.XlsType !=="SINGLE_TEMPLATE" ? 
            (newState.questionsList[action.question_id].collector.XlsType.toLowerCase().replace(/\ /g, "_") +" " + action.choiceName) : 
            newState.questionsList[action.question_id].type
          ),
        };
        newState = { ...state, choices_list: action.data};
        break
     
      case UPDATE_FORM_SETTINGS:
        newState.form_settings[action.setting_key] = action.setting_value;
        newState.form_settings["family"] = newState.form_settings["family"].replace(/\ /g, "_");
        newState.form_settings.form_id = `${newState.form_settings.family}_G${newState.form_settings.generation}`;
        break;

      case UPDATE_FORM_CONFIGS:
        newState.form_configs[action.setting_key] = action.setting_value;
        break
      
      case ADD_LANGUAGES:
        let languages = action.languages.trim().split(" ");
        let addable_languages = [];
        languages.forEach((language) => {
          if (newState.languages.indexOf(language) === -1) {
            addable_languages = [...addable_languages, language];
            newState.languages = [...newState.languages, language];
          }
          newState.questionsList['language']['label::'+language] = 'language'
        });
        
        newState = syncStateWithLanguages(newState);
        newState.choices_list = updateChoicesListLanguage(newState,languages,"add")
        newState.choices_list = updateChoicesList(newState, addable_languages, "add");
        break;

      case REMOVE_LANGUAGE:
        let initLanguages = [...newState.languages];
        initLanguages.splice(initLanguages.indexOf(action.language), 1);
        if (action.language === newState.form_settings.default_language) {
          newState.form_settings.default_language = "";
        }
        newState.languages = [...initLanguages];
        newState = syncStateWithLanguages(newState);
        newState.choices_list = updateChoicesList(newState, action.language, "remove");
        break;

      case SET_DEFAULT_LANGUAGE:
        newState.form_settings.default_language = action.language;
        break;

      case CHANGE_TAB:
        newState.tab = action.tab;
        break;

      case ADD_SCREEN:
        let name = "group_"+action.screen
        const listQuesName = Object.values(newState.questionsList).map((question)=>question.name)
        if(listQuesName.indexOf(name)>-1){
          name = "group_"+(Number(action.screen)+1)
        }
        newState.questionsList[action.screen] = {
          name: name,
          type: GROUP_QUESTION_TYPE,
          appearance: "field-list grid(weight = 6)",
          collector: { Appearance: "TRUE"}
        };
        newState.pages = { ...newState.pages, [action.screen]: []};
        newState.current_page = action.screen;
        newState.question_checked = action.screen;
        newState.question_checked_settings = newState.questionsList[action.screen];
        break;

      case SET_CURRENT_SCREEN:
        newState.current_page = action.screen;
        break;

      case TOGGLE_DRAWER:
        newState.drawer[action.anchor] = action.open;
        break;

      case DELETE_SCREEN:
        newState.drawer["questionConfig"] = false;
        const deleted = Object.keys(newState.pages).indexOf(action.screen);
        if (Object.keys(newState.pages).length === 1) {
          alert("The form must has 1 screen at least.");
          break;
        } else{
          const newPages = {...newState.pages}
          const newQuestionsList = {...newState.questionsList}
          let questionChildTemp = []
          if (deleted > 0){
            newState.current_page = Object.keys(newState.pages)[deleted - 1];
            Object.keys(newState.pages).forEach((element, index) => {
              if(index > deleted && index + 1 <= Object.keys(newState.pages).length){
                newPages[index] = newState.pages[index+1]
                newQuestionsList[index] = newState.questionsList[index+1]
              }
            });
            questionChildTemp = [...newState.pages[action.screen]]
            questionChildTemp.forEach((element) => {
              delete newQuestionsList[element]
            });
            delete newQuestionsList[Object.keys(newPages).length]
            delete newPages[Object.keys(newPages).length]
            newState.pages = {...newPages}
            newState.questionsList = {...newQuestionsList}
          }else{
            Object.keys(newState.pages).forEach((element, index) => {
              if(index + 1 <= Object.keys(newState.pages).length){
                newPages[index+1] = newState.pages[index+2]
                newQuestionsList[index+1] = newState.questionsList[index+2]
              }
            });
            questionChildTemp = [...newState.pages[action.screen]]
            questionChildTemp.forEach((element) => {
              delete newQuestionsList[element]
            });
            delete newQuestionsList[Object.keys(newPages).length]
            delete newPages[Object.keys(newPages).length]
            newState.pages = {...newPages}
            newState.questionsList = {...newQuestionsList}
            newState.current_page = Object.keys(newState.pages)[0]
          }
          
         
        }
        newState.question_checked = "";
        newState.question_checked_settings = {};
        break;

      case ADD_QUESTION_INTO_PARENT:
        newState.questionsList[action.parent].children.splice(action.destination_index, 0, action.question_id);
        const page = state.pages[newState.current_page];
        page.splice(page.indexOf(action.question_id), 1);
        newState.pages[newState.current_page] = page;
        break;

      case TAKE_OUT_GROUP_QUESTIONS:
        newState.questionsList[action.parent].children.splice(action.source_index, 1);
        newState.pages[newState.current_page].splice(action.destination_index, 0, action.question_id);
        break;

      case SORT_IN_GROUP_QUESTIONS:
        newQuestionsList = [...newState.questionsList[action.question_id]];
        const [removedIndex] = newQuestionsList.splice(action.source_index, 1);
        newQuestionsList.splice(action.destination_index, 0, removedIndex);
        newState.questionsList[action.question_id] = newQuestionsList;
        break;

      case  UPDATE_THEME_SETTING:
        newState.theme_config[action.key_theme] = action.value_theme
        let key = action.key_theme
        let r = document.querySelector(':root');
        switch (key) {
          case 'font_family':
              r.style.setProperty("--"+key.replace(/\_/g,"-"),`${action.value_theme}, sans-serif`);
              break;
          case 'background_brightness':
              let value_theme_background_brightness = action.value_theme ? action.value_theme : 0
              let colorBrightNess =value_theme_background_brightness >= 0 ? 255 : 0;
              let brightNess = Math.abs(value_theme_background_brightness/100);
              r.style.setProperty("--color-brightness",colorBrightNess);
              r.style.setProperty("--background-image-brightness",brightNess);
              break;
          case 'answer_color':
              r.style.setProperty("--answer-color",action.value_theme);
              r.style.setProperty("--answer-color-opacity",hexToRgbA(action.value_theme, 0.4));
              r.style.setProperty("--answer-background-opacity",hexToRgbA(action.value_theme, 0.1));
              r.style.setProperty("--answer-background-hover",hexToRgbA(action.value_theme, 0.3));
              break
          case 'primary_color':
              r.style.setProperty("--primary-color",action.value_theme);
              r.style.setProperty("--primary-color-opacity",hexToRgbA(action.value_theme, 0.2));
              break
          case 'font_size':
              let fontSize = action.value_theme.replace("px","")
              r.style.setProperty("--font-size",action.value_theme);
              r.style.setProperty("--font-size-mobile",(fontSize - (fontSize/5))+"px");
              break
          case "intro_content":
          case "logo":
          case "show_powered_btn":
          case "show_shortcuts":
          case "show_scroll":
          case "show_welcome_screen":
          case "type_shortcuts":
          case "position_pagination":
              break;
          default:
              r.style.setProperty("--"+key.replace(/\_/g,"-"), action.value_theme);
              break;
      }
        break;
      
        default:
        break;
    }
    // console.log("newState", action, newState);
    return newState;
  } catch (e) {
    console.log(action, e);
    return newState;
  }
}

function syncStateWithLanguages(state) {
  let setting_keys = ["label", "hint", "required_message", "constraint_message"];
  let newState = { ...state };

  newState.languages.forEach((language) => {
    Object.keys(newState.questionsList).forEach((question) => {
      setting_keys.forEach((key) => {
        if(newState.questionsList[question][`${key}::${language}`] === undefined){
          newState.questionsList[question][`${key}::${language}`] = newState.questionsList[question][key];
        }
      });
    });
    newState.question_checked_settings && setting_keys.forEach((key) => {
      if(newState.question_checked_settings[`${key}::${language}`] === undefined){
        newState.question_checked_settings[`${key}::${language}`] = newState.question_checked_settings[key];
      }
    });
  });
  return newState;
}

function updateChoicesList(state, languages, type) {
  if (type === "add") {
    return updateChoicesListAfterAddingLanguage(state, languages);
  } else {
    return updateChoicesListAfterRemovingLanguage(state, languages);
  }
}

function updateChoicesListLanguage(state, languages, type) {
  if (type === "add") {
    const header = state.choices_list[0]
    let newChoiceLanguages = []
    languages.forEach((language)=>{
      let newChoiceLanguage = []
      header.forEach((key)=>{
        if(key === "list_name"){
          newChoiceLanguage= [...newChoiceLanguage,'language']
        }else if(key === 'name' || key.indexOf('label::')>-1){
          newChoiceLanguage = [...newChoiceLanguage,language]
        }
      })
      newChoiceLanguages = [...newChoiceLanguages,newChoiceLanguage]
    })
    let choicesListUpdate = [...state.choices_list,...newChoiceLanguages  ];
    return choicesListUpdate
  } else {
    let choices_list = state.choices_list
    const header = state.choices_list[0]
    languages.forEach((language)=>{
      let item = {}
      header.forEach((a)=>{
          if(a === 'list_name'){
              item[a] = 'language'
          }else if( a === 'name' || a.indexOf('label::')>-1){
              item[a] = language
          }else{
              item[a] = null
          }
      })
      deleteItem(choices_list,item)
    })
    return choices_list
  }
}

function updateChoicesListAfterRemovingLanguage(state, removed_language) {
  let old_choices_list = [...state.choices_list];
  let choice_headers = [...state.choices_list[0]];
  let new_choices_list = [];

  if (state.languages.length === 0) {
    for (let i = 0; i < choice_headers.length; i++) {
      if (choice_headers[i].indexOf("label") > -1) {
        choice_headers[i] = "label";
      }
      if (choice_headers[i].indexOf("media::image") > -1) {
        choice_headers[i] = "media::image";
      }
    }
    old_choices_list[0] = choice_headers;
    return old_choices_list;
  }

  let removed_label_index = choice_headers.indexOf( `label::${removed_language}` );
  choice_headers.splice(removed_label_index, 1);
  let removed_media_image_index = choice_headers.indexOf( `media::image::${removed_language}`);
  choice_headers.splice(removed_media_image_index, 1);
  new_choices_list.push(choice_headers);

  for (let i = 1; i < old_choices_list.length; i++) {
    let new_choices_list_row = old_choices_list[i];
    new_choices_list_row.splice(removed_label_index, 1);
    new_choices_list_row.splice(removed_media_image_index, 1);
    new_choices_list.push(new_choices_list_row);
  }
  return new_choices_list;
}

function updateChoicesListAfterAddingLanguage(state, addable_languages) {
  let old_choices_list = [...state.choices_list];
  let new_choices_list = [];
  let new_choices_list_row = [];
  let choice_columns = [...state.choices_list[0]];
  let label_last_index = choice_columns.indexOf( `label::${state.languages[state.languages.length - addable_languages.length - 1]}`);

  if (label_last_index === -1) {
    for (let i = 0; i < old_choices_list.length; i++) {
      new_choices_list_row = [];
      choice_columns.forEach((column, column_index) => {
        if ((column === "label" || column === "media::image") && state.languages.length > 0) {
          state.languages.forEach((language) => {
            if (i === 0) {
              new_choices_list_row = [ ...new_choices_list_row, `${column}::${language}`];
            } else {
              new_choices_list_row = [...new_choices_list_row, old_choices_list[i][column_index]];
            }
          });
        } else {
          if (i === 0) {
            new_choices_list_row = [...new_choices_list_row, column];
          } else {
            new_choices_list_row = [ ...new_choices_list_row, old_choices_list[i][column_index]];
          }
        }
      });
      new_choices_list.push(new_choices_list_row);
    }
  } else if (label_last_index > -1) {
    let new_headers = [];
    for (let i = 0; i < old_choices_list.length; i++) {
      new_choices_list_row = [...old_choices_list[i]];
      addable_languages.forEach((language, lang_index) => {
        if (i === 0) {
          new_choices_list_row.splice(label_last_index + lang_index + 1, 0, `label::${language}`);
          new_headers = new_choices_list_row;
        } else {
          new_choices_list_row.splice(label_last_index + lang_index + 1, 0, null);
        }
        let media_image_last_index = new_headers.indexOf(
          `media::image::${ state.languages[ state.languages.length - addable_languages.length - 1 ]}`
        );
        if (i === 0) {
          new_choices_list_row.splice(media_image_last_index + lang_index + 1, 0,`media::image::${language}`);
          new_headers = new_choices_list_row;
        } else {
          new_choices_list_row.splice(media_image_last_index + lang_index + 1,0,null);
        }
      });
      new_choices_list.push(new_choices_list_row);
    }
  }
  return new_choices_list;
}

function setAppearance(display=['displaytitle invisible'], gridformat) {
  let gridArr = [];
  for (let prop in gridformat) {
    if (gridformat[prop] !== "") {
      gridArr = [...gridArr, `${prop} = ${gridformat[prop]}`];
    }
  }
  let gridStr = gridArr.join(", ");
  let appearance = `${display?.join(" ")} gridformat<${gridStr}/>`;
  return appearance;
}

function parseGridFormat(str,question_id) {
  const regex = /gridformat<\s*row\s*=\s*(\d+)\s*,\s*col\s*=\s*(\d+)\s*,?\s*(rowspan\s*=\s*(\d+)\s*,?)?\s*colspan\s*=\s*(\d+)\s*,?\s*(align\s*=\s*(left|center|right)\s*,?)?\s*(backgroundcolor\s*=\s*#?\w+)?\s*\/>/;
  const match = str.match(regex);

  if (match) {
    return {
      row: question_id + Number(match[1]),
      col: Number(match[2]),
      rowspan: match[4] ? Number(match[4]) : '',
      colspan: Number(match[5]),
      align: match[7] ? match[7] : '',
      backgroundcolor: match[8] ? match[8] : ''
    };
  } else {
    return {};
  }
}

function handleQuestionSingleTemplate(action,question){
  let newQuestion = JSON.parse(JSON.stringify(GENERAL_QUESTION_SETTINGS));
  newQuestion.name = question.question_id;
  newQuestion.type = question.question_type;
  newQuestion.collector = question.question_collector;
  Object.entries(question).forEach((arrChild  )=>{
      newQuestion[arrChild[0]] = arrChild[1]
      if(arrChild[0] === "type" && action.question_type.indexOf("select")>-1){
        let type = action.question_type.split(" ")
        newQuestion["type"] = action.question_type
        newQuestion['choice'] = type[1]
        newQuestion['choices_list'] = type[1]
        
      }
  })
  newQuestion["gridformat"] = question["gridformat"] ? parseGridFormat(question["gridformat"],action.question_id) : {}
  newQuestion["display"] = question["display"]?.length > 0 ? question["display"].split(" ") : []
  
  if (newQuestion.type !== GROUP_QUESTION_TYPE && newQuestion.type !== CALCULATE_QUESTION_TYPE) {
    newQuestion.appearance = setAppearance(
      newQuestion["display"],
      newQuestion["gridformat"]
    );
  }
  return newQuestion
}

function handleNewListChild(action,state,newState){
  action.list_child.forEach((child,index) =>{
    let newQuestion = JSON.parse(JSON.stringify(GENERAL_QUESTION_SETTINGS));
    newQuestion.name = child.question_id;
    newQuestion.type = child.question_type === 'button' ? 'text' : child.question_type;
    newQuestion.collector = child.question_collector;
    Object.entries(child.question).forEach((arrChild  )=>{
        newQuestion[arrChild[0]] = arrChild[1]
        if(arrChild[0] === "type" && arrChild[1].indexOf("select")>-1){
          let type = arrChild[1].split(" ")
          newQuestion[arrChild[0]] = type[0].replace("_"," ")
          newQuestion['choice'] = type[1]
        }
        if(arrChild[0] === "name" && arrChild[1].length === 0){
          newQuestion['name'] = child.question_id
        }
    })
    newQuestion["gridformat"] = newQuestion["gridformat"] ? parseGridFormat(newQuestion["gridformat"],action.question_id) : {}
    newQuestion["display"] = newQuestion["display"].length > 0 ? newQuestion["display"].split(" ") : []
    
    if (newQuestion.type !== GROUP_QUESTION_TYPE && newQuestion.type !== CALCULATE_QUESTION_TYPE) {
      newQuestion.appearance = setAppearance(newQuestion["display"],newQuestion["gridformat"]);
    }
    newState.questionsList[child.question_id] = newQuestion;
  
    if (newState.pages[action.page_name]) {
      newState.pages[action.page_name].splice(action.destination_index, 0, child.question_id);
    } else {
      newState.pages = {[action.page_name]: child.question_id};
    }
    
    newState.questionsList[action.question_id].children.splice(index, 0, child.question_id );
    const page = state.pages[newState.current_page];
    page.splice(page.indexOf(child.question_id), 1);
    newState.pages[newState.current_page] = page;
  })
}

function handleGrid(newState, page){
  
  let arr = Object.keys(newState.questionsList).map((key)=>{
      return newState.questionsList[key]?.gridformat?.row
  })

  let duplicates = arr.reduce((acc, item, index) => {
    if (arr.indexOf(item) !== arr.lastIndexOf(item) && !acc.includes(item)) {
      acc.push(newState.questionsList[Object.keys(newState.questionsList)[index]].name);
    }
    return acc;
  }, []);
  let arrayPage = newState.pages[page]
  let newArrayPage = [...arrayPage]
  arrayPage.forEach((element,index)=>{
    if(newState.questionsList[element].collector?.AppearanceGroup.indexOf("GROUP_TEMPLATE")>-1){
      let listChild = newState.questionsList[element].children
      newArrayPage.splice(index+1, 0, ...listChild)
    }
  })
  for(let i=0;i<newArrayPage.length;i++){
    if(newState.questionsList[newArrayPage[i]] && (newState.questionsList[newArrayPage[i]].type !== GROUP_QUESTION_TYPE && newState.questionsList[newArrayPage[i]].type !== CALCULATE_QUESTION_TYPE)){
      if(duplicates.indexOf(newArrayPage[i-1])>-1){
        newState.questionsList[newArrayPage[i]]["gridformat"].row = i-1
      }else{
        newState.questionsList[newArrayPage[i]]["gridformat"].row = i
      }
      let temp=0
      for(let i=0;i<newState.pages[page].length;i++){
        if(newState.questionsList[newState.pages[page][i]]?.gridformat.colspan < 6 && temp<6){
            temp += newState.questionsList[newState.pages[page][i]]?.gridformat.colspan
        }else{
            temp = 0 
        }
        if(temp > 0 && newState.questionsList[newState.pages[page][i-1]]?.gridformat.colspan < 6){
            newState.questionsList[newState.pages[page][i]].gridformat.row = newState.questionsList[newState.pages[page][i-1]]?.gridformat.row 
            newState.questionsList[newState.pages[page][i]].gridformat.col = newState.questionsList[newState.pages[page][i-1]]?.gridformat.col + newState.questionsList[newState.pages[page][i-1]]?.gridformat.colspan 
          }
      }
      newState.questionsList[newArrayPage[i]]["appearance"] = setAppearance( newState.questionsList[newArrayPage[i]]["display"], newState.questionsList[newArrayPage[i]]["gridformat"]);
    }
  }
  return newState
}

function hexToRgbA(hex, opacity){
  var c;
  if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
      c= hex.substring(1).split('');
      if(c.length=== 3){
          c= [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c= '0x'+c.join('');
      return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+opacity+')';
  }
  throw new Error('Bad Hex');
}